import { useEffect } from 'react';
import { PLATFORM_URL } from '../containers/App/constants';

const useCollisionStyle = (...cssPaths) => {
  useEffect(() => {
    const links = cssPaths.map((cssPath) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `${PLATFORM_URL}/asset_path/${cssPath}`;
      document.body.appendChild(link);

      return link;
    });

    return () => {
      if (links) {
        links.forEach((link) => link.remove());
      }
    };
  }, [false]);
};

export default useCollisionStyle;



// WEBPACK FOOTER //
// ./app/utils/useCollisionStyle.js